module.exports = __webpack_public_path__ + "img/icon_fudai@2x.685ef5a0.png";